// extracted by mini-css-extract-plugin
export default {"event-discussion-feed":"EventDiscussionFeed_event-discussion-feed__mjCj9","event-discussion-feed__empty":"EventDiscussionFeed_event-discussion-feed__empty__gpMdY"};